<template>
  <div
    class="SearchGalleryResults"
    v-scroll="{ handleScroll }">

    <p
      class="SearchGalleryResults_no-results"
      v-if="!results.length">
      There were no results
    </p>

    <div
      class="SearchGalleryResults_Result"
      v-for="app in results"
      :key="app.appstoreID">
      <AppCard
        :app="app"
        :is-loading="isLoading"
        :is-logo-square="isLogosSquare"
        @click="handleAppCardClick"
      />
    </div>

    <div
      class="SearchGalleryResults_End">
      <BaseLoader
        v-show="isPaginating"
        size="large"
      />
    </div>

  </div>
</template>

<script>
import { throttle } from 'lodash';
import AppCard from '@/components/AppCard.vue';
import BaseLoader from '@/components/BaseLoader.vue';

export default {
  name: 'SearchGalleryResults',

  components: {
    AppCard,
    BaseLoader,
  },

  props: {
    results:       { type: Array,   default: () => [] },
    isLoading:     { type: Boolean, default: true },
    isPaginating:  { type: Boolean, default: false },
    isLogosSquare: { type: Boolean, default: true },
  },

  methods: {
    handleAppCardClick(app) {
      this.$emit('click-result', app);
    },

    handleScroll: throttle(function handleScrollThrottled() {
      if (this.isPaginating) return;

      const { scrollHeight, scrollTop } = this.$el;

      const isReadyToPaginate = scrollHeight - scrollTop < 2500;

      if (isReadyToPaginate) this.$emit('paginate');
    }, 100),

    scrollToTopOfResults() {
      this.$el.scrollTop = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

@media only screen and (max-width: 640px) {
  .SearchGalleryResults_Result {
    padding-bottom: 0 !important;
  }
}

.SearchGalleryResults {
  display: flex;
  flex-wrap: wrap;
  overflow-x: hidden;
}

.SearchGalleryResults_no-results {
  padding-left: 12px;
  font-size: 24px;
}

.SearchGalleryResults_Result {
  flex: 1 1 100%;
  padding-bottom: 16px;
}

.SearchGalleryResults_End {
  flex: 1 0 100%;
  width: 100%;
  padding-top: 8px;
  text-align: center;
}

@media only screen and (min-width: 875px) {
  .SearchGalleryResults_Result {
    flex: 1 1 50%;
    max-width: 50%;
  }
}

@media only screen and (min-width: 1200px) {
  .SearchGalleryResults_Result {
    flex: 1 1 33.3333%;
    max-width: 33.3333%;
  }
}

@media only screen and (min-width: 1600px) {
  .SearchGalleryResults_Result {
    flex: 1 1 25%;
    max-width: 25%;
  }
}

@media only screen and (min-width: 2000px) {
  .SearchGalleryResults_Result {
    flex: 1 1 20%;
    max-width: 20%;
  }
}

@media only screen and (min-width: 2400px) {
  .SearchGalleryResults_Result {
    flex: 1 1 16.6666%;
    max-width: 16.6667%;
  }
}
</style>
